<template>
  <!--弹窗-->
  <el-dialog width="600px" :title="title" :visible.sync="visible" :before-close="handleClose" top="10vh">
        <el-form ref="formData" :model="formData" label-width="170px">
            <el-form-item label="用户编号：" prop="amount">
                <span>{{formData.id}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="amount">
                <span>{{formData.name}}</span>
            </el-form-item>
            <el-form-item label="公司名称：" prop="amount">
                <span>{{formData.company}}</span>
            </el-form-item>
            <el-form-item label="电话号码：" prop="amount">
                <span>{{formData.tel}}</span>
            </el-form-item>
            <el-form-item label="QQ账号：" prop="amount">
                <span>{{formData.qq}}</span>
            </el-form-item>
            <el-form-item label="微信号：" prop="amount">
                <span>{{formData.wechat}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="amount">
                <span>{{formData.email}}</span>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button style="float:right" size="mini" type="primary" @click="handleClose()">确定</el-button>
        </el-row>
  </el-dialog>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 关闭弹窗
        handleClose() {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", true);
        }
    }
};
</script>
